import { Action } from 'redux';

// State
export interface OpenDesignState {
	showOpenDesign: boolean;
	openDesignInput: string;
}

// Actions
export const SET_SHOW_OPEN_DESIGN = 'SET_SHOW_OPEN_DESIGN';
export const SET_OPEN_DESIGN_INPUT = 'SET_OPEN_DESIGN_INPUT';

interface SetShowOpenDesign extends Action {
	type: typeof SET_SHOW_OPEN_DESIGN;
	value: boolean;
}

interface SetOpenDesignInpu extends Action {
	type: typeof SET_OPEN_DESIGN_INPUT;
	value: string;
}

export type OpenDesignStateActions = SetShowOpenDesign | SetOpenDesignInpu;
